var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDepartment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.62901 10.6562V8.20122H9.1343L9.1343 16.3845L10.8869 16.3847V8.20122L14.3922 8.20123L14.3922 10.7217H16.1447L16.1449 8.20123C16.1449 7.30106 15.3562 6.56457 14.3922 6.56457H10.8869L10.8869 3.14395L9.1343 3.14395V6.56457H5.62901C4.66506 6.56457 3.87637 7.30106 3.87637 8.20122L3.87637 10.6562H5.62901Z",
    fill: "#2B59A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27749 1H11.7793V4.27005H8.27749V1Z",
    fill: "#2B59A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27749 15.73H11.7793V19H8.27749V15.73Z",
    fill: "#2B59A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4987 9.83797H17.0005V13.108H13.4987V9.83797Z",
    fill: "#2B59A3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00049 9.83799H6.50227V13.108H3.00049V9.83799Z",
    fill: "#2B59A3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartment);
export default __webpack_public_path__ + "static/media/department.4b7d707e.svg";
export { ForwardRef as ReactComponent };